export default __webpack_public_path__ + "static/media/practo3.27030be4.png";